Namespace 'Settings.Views.Topics.LinkedIn'

class Settings.Views.Topics.LinkedIn.LinkedInOrganizationsModal extends Backbone.View
  template: JST['backbone/templates/settings/topics/linked_in_organizations_modal']

  events:
    'click .linkedin-organizations-modal-submit': 'submit'

  initialize: (collection, urnInput, acceptButton) ->
    @collection = collection
    @urnInput = urnInput
    @acceptButton = acceptButton

  render: ->
    @collection.fetchOrganizations().then(=>
      @$el.html(@template({organizations: @collection.organizations()}))
      @$el.find('#linkedin-organization-urn-modal').modal()
      @$el.find('.trigger-modal').modal()
    )
    @

  submit: ->
    urn = @$el.find('#organizations-selector').val()
    @urnInput.val(urn)
    @acceptButton.removeClass('disabled')
    @$el.find('#linkedin-organization-urn-modal').modal('hide')

  setOnChange: (el) ->
    @urnInput = el
